import type { Client } from './client';
import type { AxiosError } from 'axios';

export type CompanyFeatureFlags = Record<string, boolean>;

export type B2BProvisioningStatus =
  'unlinked' | 'pending' | 'linked' | 'conflict' | 'manual_action';

export const DEFAULT_COMPANY_FEATURE_FLAGS: CompanyFeatureFlags = {
  documents: true,
  documentsUpload: true,
};

export interface Company {
  // WTF typo in prisma
  Client?: Client[];
  avatarUrl: string;
  b2bOrganizationId?: string | null;
  b2bProvisioningMessage?: string | null;
  b2bProvisioningStatus: B2BProvisioningStatus;
  createdAt: string;
  culture: string;
  adminEmails: string[];
  b2b_organization_id?: string | null;
  contractedMembersCount?: number;
  contractedSeats?: number | null;
  disallowedEmails: string[];
  domainMembersSelfPay?: boolean;
  domains: string[];
  emails: string[];
  goals: string[];
  id: string;
  industry: string;
  isActive: boolean;
  linkedin: string;
  location: string;
  name: string;
  pocEmail: string;
  pocName: string;
  featureFlags: CompanyFeatureFlags;
  requiredAuthMethod?: 'oauth' | 'magic_link' | null;
  selfPaidMembersCount?: number;
  sessionTimeoutLength: number | null;
  updatedAt: string;
  usersCount: number;
  vision: string;
  website: string;
  required_auth_method?: 'oauth' | 'magic_link' | null;
}

export interface CompanyForm {
  avatarUrl: string;
  culture: string;
  adminEmails: string;
  contractedSeats?: number | null;
  disallowedEmails: string;
  domainMembersSelfPay?: boolean;
  domains: string;
  emails: string;
  industry: string;
  linkedin: string;
  location: string;
  name: string;
  pocEmail: string;
  pocName: string;
  featureFlags: CompanyFeatureFlags;
  sessionTimeoutLength: number | null;
  required_auth_method?: 'oauth' | 'magic_link' | null;
  vision: string;
  website: string;
}

export interface CompanyStats {
  feedback: CompanyFeedback;
  hoursCompleted: number;
  sessionsCompleted: number;
  activeSeats?: {
    executive: number;
    leadership: number;
  };
}

export interface CompanyStatsReturnType {
  error: AxiosError | null;
  stats: CompanyStats;
}

export interface CompanyFeedback {
  later: number;
  mixed: number;
  negative: number;
  positive: number;
}

export interface UsersEngagement {
  active: number;
  clientsWithCoach: number;
  engaged: number;
  last_30Days: number;
  next_30Days: number;
}

export const getCompanyB2BOrganizationId = (
  company?: Partial<Company> | null,
): string | null =>
  company?.b2bOrganizationId ?? company?.b2b_organization_id ?? null;

export const getCompanyRequiredAuthMethod = (
  company?: Partial<Company> | null,
): 'oauth' | 'magic_link' | null =>
  company?.requiredAuthMethod ?? company?.required_auth_method ?? null;
